import { createEntryPoint } from '#packages/apilib';
import { StageContextScope } from './stageContextScope';
import { StageContextApi } from './stageContextApi';
import { StageContextApiKey } from './publicApiKey';

import type { StageContext } from './stageContextTypes';

export const StageContextEntryPoint = createEntryPoint({
  name: 'StageContext',
  Scope: StageContextScope,
  publicApi({ contributeApi }) {
    contributeApi(StageContextApiKey, StageContextApi);
  },
});

export { StageContextApiKey };
export type { StageContextApi };
export type { StageContext };
